












import BaseComponent from '@/components/base-component.vue';
import { listCitiesByUf } from '@/services/address';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiAutocompleteCity extends BaseComponent {
  @Prop()
  value: any;

  @Prop()
  uf: any;

  selected: any = null;

  loading = false;
  cities = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  @Watch('uf', { immediate: true })
  onUfChange(v) {
    this.load();
  }

  load() {
    this.loading = true;
    listCitiesByUf(this.uf).subscribe(
      (res) => {
        this.cities = res;
        this.loading = false;
        if (!!this.selected) {
          this.selected = this.cities.find((c) => c == this.selected);
          this.onChange();
        }
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  onChange() {
    this.$emit('input', this.selected);
    this.$emit('change', this.selected);
  }
}
